import { PATH_ASSETS, PATH_BASE } from './AppConstants';

export default class UrlResolver {
  constructor(game) {
    this.game = game;
  }

  // get main directory
  getBaseDirectory() {
    return PATH_BASE;
  }

  // resolves relativly given url
  resolveRelatveUrl(path) {
    return this.getBaseDirectory() + path;
  }

  // get the root of the assets folder, pass in relative url for extended path
  getAssetsDirectory(urlSuffix) {
    return urlSuffix
      ? this.resolveRelatveUrl(PATH_ASSETS + urlSuffix)
      : this.resolveRelatveUrl(PATH_ASSETS);
  }

  // get the url to a game assets folder based on minigameid
  getGameAssetsDirectory(gameID, urlSuffix) {
    return urlSuffix
      ? this.resolveRelatveUrl(PATH_ASSETS + 'games/' + gameID + '/' + urlSuffix)
      : this.resolveRelatveUrl(PATH_ASSETS + 'games/' + gameID + '/');
  }

  getFontsDirectory(urlSuffix) {
    return this.getAssetsDirectory('fonts/' + urlSuffix);
  }

  getLocationBackground(id) {
    return 'locations/' + id + '/background.jpg';
  }

  getLocationCreatures(id) {
    return 'spritesheets/' + id + '/creatures';
  }

  getCopyXML(id) {
    return 'locale/' + id + '.xml';
  }

  getResultImage(id) {
    return 'ui/images/result_' + id + '.png';
  }
}
